<template>
  <div class="event-tab">
    <SubpanelTable
      v-if="tableTitle && tableList && tableList.length"
      :tableColumns="tableTitle"
      :tableData="tableList"
      @handleDelete="openDeleteDialog"
      @rowClick="openEventDialog"
      subpanelName="event"
      :style="tableHeight"
    ></SubpanelTable>
    <div v-else>
      <Alert text="Событий еще нет" />
    </div>
  </div>
</template>
<script>
import { mixin, errorMsg } from '@/utils/mixins';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import Alert from 'Elements/Alert/Alert';
import { store } from '@/store';
import { getController } from '@/controllers/request.js';

import { DIALOG_WIDTH, EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';

export default {
  mixins: [mixin, errorMsg],
  props: {
    metadata: [Array, Object]
  },
  data() {
    return {
      tableTitle: null,
      tableList: null,
      is_visible: {
        delete_event_dialog: false
      },
      delete_params: {},
      candidateId: '',
      deleteDialogWidth: null
    };
  },
  created() {
    if (this.metadata.data && this.metadata.data.title) {
      this.tableTitle = this.metadata.data.title;
    }
    if (this.metadata.data && this.metadata.data.List) {
      this.tableList = this.metadata.data.List;
    }
    eventBus.$on(EVENTBUS_EVENTS.DELETE_EVENT, this.deleteEvent);
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.DELETE_EVENT, this.deleteEvent);
  },
  methods: {
    openEventDialog(item) {
      store.commit('candidate/setSelectedMeeting', item);
      store.commit('common/setVisibleDialog', {
        name: 'event_view_dialog',
        val: true
      });
    },
    async openDeleteDialog(row) {
      if (row.delete?.intent?.request) {
        try {
          this.deleteDialogWidth =
            DIALOG_WIDTH[row.delete?.intent.size] || DIALOG_WIDTH.S;

          const response = await getController({
            params: row.delete.intent.request.request_params,
            url: row.delete.intent.request.url
          });
          if (response && response.data) {
            this.delete_params = response.data;
            this.candidateId =
              row.delete.intent.request.request_params.candidate_id;
            this.$set(this.is_visible, 'delete_event_dialog', true);
            eventBus.$emit('open-delete-event-dialog', {
              candidateId: this.candidateId,
              delete_params: this.delete_params,
              deleteDialogWidth: this.deleteDialogWidth
            });
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка при завершении импорта',
            'upload file'
          );
        }
      }
    },
    async deleteEvent() {
      if (
        this.delete_params?.metadata?.buttons_menu &&
        this.delete_params.metadata.buttons_menu[0]
      ) {
        for (let i in this.delete_params.metadata.buttons_menu[0]) {
          if (this.delete_params.metadata.buttons_menu[0][i].name == 'delete') {
            const deleteIntens =
              this.delete_params.metadata.buttons_menu[0][i].intents;
            try {
              await getController({
                params: deleteIntens[1].request.request_params,
                url: deleteIntens[1].request.url
              });
            } catch (err) {
              console.error(
                err,
                'Возникла ошибка при завершении импорта',
                'upload file'
              );
            }
          }
        }
      }
      this.$emit('reloadTab');
    }
  },
  computed: {
    tableHeight() {
      return `min-height: ${52 + (this.tableList?.length || 0) * 48.9}px`;
    }
  },
  components: {
    SubpanelTable,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.event-tab {
  padding: 24px;
  background: $white;
  border-radius: 4px;
}
</style>
